var jinrong = {
  "AppId": "",
  "lookback": [
    {
      "title": "2016年回顾",
      "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/namelist2016.png",
      "detail": [
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2016-1.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2016-2.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2016-3.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2016-4.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2016-5.jpg"
      ]
    },
    {
      "title": "2017年回顾",
      "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/namelist2017.png",
      "detail": [
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2017-1.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2017-2.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2017-3.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2017-4.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2017-5.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2017-6.jpg"
      ]
    },
    {
      "title": "2018年回顾",
      "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/namelist2018.png",
      "detail": [
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2018-1.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2018-2.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2018-3.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2018-4.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2018-5.jpg",
        "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/lookback/list2018-6.jpg"
      ]
    }
  ],
  "staytuned": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/staytuned.jpg"],
  "yinfajiang": [
    "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/yinfajiang-1.jpg",
    "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/yinfajiang-2.jpg",
    "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/yinfajiang-3.jpg",
    "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/yinfajiang-4.jpg",
    "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/yinfajiang-5.jpg",
    "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/yinfajiang-6.jpg",
    "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/yinfajiang-7.jpg"
  ],
  "newproduct": {
    "pic": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/newproduct2020.png",
    "list": [
      {
        "title": "百行征信",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/baixing.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/baixing.jpg"]
      },
      {
        "title": "福建升腾",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/fujianshengteng.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/fujianshengteng.jpg"]
      },
      {
        "title": "广电运通",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/guangdianyunshu.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/guangdianyunshu.jpg"]
      },
      {
        "title": "江苏城印",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/jiangsuchengyin.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/jiangsuchengyin.jpg"]
      },
      {
        "title": "江苏南大",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/jiangsunanda.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/jiangsunanda.jpg"]
      },
      {
        "title": "金山云",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/jinshanyun.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/jinshanyun.jpg"]
      },
      {
        "title": "科沃斯",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/kewosi.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/kewosi.jpg"]
      },
      {
        "title": "浪潮商用",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/langchaoshangyong.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/langchaoshangyong.jpg"]
      },
      {
        "title": "绿盟科技",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/lvmengkeji.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/lvmengkeji.jpg"]
      },
      {
        "title": "深圳杉岩",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/shenzhenshanyan.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/shenzhenshanyan.jpg"]
      },
      {
        "title": "神州信息",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/shenzhouxinxi.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/shenzhouxinxi.jpg"]
      },
      {
        "title": "腾讯云",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/tengxunyun.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/tengxunyun.jpg"]
      },
      {
        "title": "天津南大通用",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/nandatongyong.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/nandatongyong.jpg"]
      },
      {
        "title": "统信软件",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/tongxinruanjian.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/tongxinruanjian.jpg"]
      },
      {
        "title": "御风科技",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/yufengkeji.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/yufengkeji.jpg"]
      },
      {
        "title": "悦锦软件",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/yuemianruanjian.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/yuemianruanjian.jpg"]
      },
      {
        "title": "南天电子",
        "src": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/yunnannantian.png",
        "detail": ["https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/newproduct/detail/yunnannantian.jpg"]
      }
    ]
  },
  "opening": [
    {
      "date": "",
      "title": "2020中国国际金融展开幕式",
      "vid": "x3163max7n8",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/9.24%20%E9%87%91%E8%9E%8D%E5%B1%95%E5%BC%80%E5%B9%95%E5%BC%8F.mp4",
      "bgimg": "4",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_1.png',
      "disabled": true
    },
    {
      "date": "",
      "title": "2019年度金融科技发展奖颁奖仪式",
      "vid": "v3163yqaq03",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/9.24%20%E4%B8%8A%E5%8D%88%E9%A2%81%E5%A5%96%E7%8E%AF%E8%8A%82.mp4",
      "bgimg": "2",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_2.png',
      "disabled": true
    },
    {
      "date": "",
      "title": "2020中国国际金融展新品发布会",
      "vid": "w31634txl2o",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/9.24%20%E9%87%91%E8%9E%8D%E5%B1%95%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83%E4%BC%9A.mp4",
      "bgimg": "3",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
    },
    {
      "date": "",
      "title": "工行分布式技术体系-大型银行分布式架构转型的实践",
      "vid": "g3163xvge5j",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/1-%E5%B7%A5%E8%A1%8C%E5%88%86%E5%B8%83%E5%BC%8F%E6%8A%80%E6%9C%AF%E4%BD%93%E7%B3%BB.mp4",
      "bgimg": "1",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
    },
    {
      "date": "",
      "title": "芯数云边、生态金融——结伴金融科技持续发展",
      "vid": "c3163mw3oon",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/2-%E8%8A%AF%E6%95%B0%E4%BA%91%E8%BE%B9%20%E5%8D%8E%E4%B8%BA.mp4",
      "bgimg": "1",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
    },
    {
      "date": "",
      "title": "中国农业银行技术中台",
      "vid": "t3163ket9xb",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3-%E5%86%9C%E4%B8%9A%E9%93%B6%E8%A1%8C%E6%8A%80%E6%9C%AF%E5%B9%B3%E5%8F%B0.mp4",
      "bgimg": "1",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
    },
    {
      "date": "",
      "title": "数字经济筑路者 加速金融数字化转型",
      "vid": "l3163g4bdhg",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/4-%E6%95%B0%E5%AD%97%E7%BB%8F%E6%B5%8E%E7%AD%91%E8%B7%AF%E8%80%85%20%E4%B8%AD%E5%85%B4.mp4",
      "bgimg": "1",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
    },
    {
      "date": "",
      "title": "“e企赢”，为企业的全球发展梦想插上翅膀",
      "vid": "e3163hs2364",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/5-%E4%B8%AD%E5%9B%BD%E9%93%B6%E8%A1%8CE%E8%B5%B7%E8%B5%A2.mp4",
      "bgimg": "1",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
    },
    {
      "date": "",
      "title": "易鲸捷国产分布式数据库银行核心交易系统落地实践",
      "vid": "i31637ba81r",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/6-%E6%98%93%E9%B2%B8%E6%8D%B7%E5%9B%BD%E4%BA%A7%E5%88%86%E5%B8%83%E5%BC%8F.mp4",
      "bgimg": "1",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
    },
    {
      "date": "",
      "title": "中国建设银行智慧政务项目科技成果",
      "vid": "g3163k4c2qe",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/7-%E4%B8%AD%E5%9B%BD%E5%BB%BA%E8%AE%BE%E9%93%B6%E8%A1%8C%E6%99%BA%E6%85%A7%E6%94%BF%E5%8A%A1%E9%A1%B9%E7%9B%AE.mp4",
      "bgimg": "1",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
    },
    {
      "date": "",
      "title": "从疫情起伏思考网络安全未来防护思路",
      "vid": "p3163i3sjkg",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/8-%E6%96%B0%E5%86%A0%E7%96%AB%E6%83%85%E4%B8%8B%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E6%80%9D%E8%80%83.mp4",
      "bgimg": "1",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
    },
    {
      "date": "",
      "title": "中国光大银行智慧云生活生态圈分享",
      "vid": "w3163wgzlh6",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/9-%E5%85%89%E5%A4%A7%E9%93%B6%E8%A1%8C%E6%99%BA%E6%85%A7%E4%BA%91%E7%94%9F%E6%B4%BB%E7%94%9F%E6%80%81%E5%9C%88.mp4",
      "bgimg": "1",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
    },
    {
      "date": "",
      "title": "鲲鹏芯片在银行应用项目",
      "vid": "d3163szusfx",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/10-%E9%B2%B2%E9%B9%8F%E8%8A%AF%E7%89%87%20%E5%89%8D%E6%B5%B7%E5%BE%AE%E4%BC%97%E9%93%B6%E8%A1%8C.mp4",
      "bgimg": "1",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
    },
    {
      "date": "",
      "title": "从关键计算走向核心交易- TiDB 云原生 HTAP 数据库全球化金融应用实践",
      "vid": "y3163mqbtic",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/11-%E4%BB%8E%E5%85%B3%E9%94%AE%E8%AE%A1%E7%AE%97%E8%B5%B0%E5%90%91%E6%A0%B8%E5%BF%83%E4%BA%A4%E6%98%93-%E5%B9%B3%E5%87%AF%E6%98%9F%E8%BE%B0.mp4",
      "bgimg": "1",
      "bgUrl": 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activity_3.png'
    }
  ],
  "conference": [
    {
      "date": "2020年11月29日",
      "title": "湾区创见·2020网络安全大会金融安全专场",
      "vid": "1",
      "urlType": "INH5",
      "url": "/conferencelist",
      "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/act/act-bg-1.png"
    },
    {
      "date": "2020年12月18日",
      "title": "中国计算机用户协会金融信息分会年会",
      "vid": "2",
      "urlType": "URL",
      "url": "https://izt.eastfair.cn/h5-web/#/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/act/act-2-detail.jpg",
      "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/jinrong/act/act-bg-2.png"
    }
  ],
  "conferencelist": [
    {
      "date": "",
      "title": "金融基础设施网络安全合规遵从与落地实践",
      "vid": "q3215gz84gv",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3%E3%80%81%E9%87%91%E8%9E%8D%E5%AE%89%E5%85%A8%E4%B8%93%E5%9C%BA%20%20%20%E8%A2%81%E6%85%A7%E8%90%8D-%E9%87%91%E8%9E%8D%E5%9F%BA%E7%A1%80%E8%AE%BE%E6%96%BD%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E5%90%88%E8%A7%84%E9%81%B5%E4%BB%8E%E4%B8%8E%E8%90%BD%E5%9C%B0%E5%AE%9E%E8%B7%B5.mp4",
      "bgimg": "4"
    },
    {
      "date": "",
      "title": "工商银行信息安全体系建设实践",
      "vid": "y3215qp47ou",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3%E3%80%81%E9%87%91%E8%9E%8D%E5%AE%89%E5%85%A8%E4%B8%93%E5%9C%BA%20%20%E7%BD%97%E6%AF%85-%E5%B7%A5%E5%95%86%E9%93%B6%E8%A1%8C%E4%BF%A1%E6%81%AF%E5%AE%89%E5%85%A8%E4%BD%93%E7%B3%BB%E5%BB%BA%E8%AE%BE%E5%AE%9E%E8%B7%B5.mp4",
      "bgimg": "2"
    },
    {
      "date": "",
      "title": "以对抗为核心的金融网络安全运营实践",
      "vid": "c3215e6rltj",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3%E3%80%81%E9%87%91%E8%9E%8D%E5%AE%89%E5%85%A8%E4%B8%93%E5%9C%BA%20%20%E4%B8%81%E6%B5%B7%E8%99%B9-%20%E4%BB%A5%E5%AF%B9%E6%8A%97%E4%B8%BA%E6%A0%B8%E5%BF%83%E7%9A%84%E9%87%91%E8%9E%8D%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E8%BF%90%E8%90%A5%E5%AE%9E%E8%B7%B5.mp4",
      "bgimg": "3"
    },
    {
      "date": "",
      "title": "证券行业网络安全体系建设实践",
      "vid": "p32152gjl4f",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3%E3%80%81%E9%87%91%E8%9E%8D%E5%AE%89%E5%85%A8%E4%B8%93%E5%9C%BA%20%20%E5%96%BB%E5%8D%8E%E4%B8%BD-%E8%AF%81%E5%88%B8%E8%A1%8C%E4%B8%9A%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E4%BD%93%E7%B3%BB%E5%BB%BA%E8%AE%BE%E5%AE%9E%E8%B7%B5.mp4",
      "bgimg": "1"
    },
    {
      "date": "",
      "title": "创新环境下中小银行数据安全管控思考与实践",
      "vid": "o3215poanpe",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3%E3%80%81%E9%87%91%E8%9E%8D%E5%AE%89%E5%85%A8%E4%B8%93%E5%9C%BA%20%20%E7%8E%8B%E5%BF%83%E7%8E%89-%E5%88%9B%E6%96%B0%E7%8E%AF%E5%A2%83%E4%B8%8B%E4%B8%AD%E5%B0%8F%E9%93%B6%E8%A1%8C%E6%95%B0%E6%8D%AE%E5%AE%89%E5%85%A8%E7%AE%A1%E6%8E%A7%E6%80%9D%E8%80%83%E4%B8%8E%E5%AE%9E%E8%B7%B5.mp4",
      "bgimg": "1"
    },
    {
      "date": "",
      "title": "渠道转型中安全架构的演进趋势",
      "vid": "s3215c2mkpg",
      "url": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/jinrong/3%E3%80%81%E9%87%91%E8%9E%8D%E5%AE%89%E5%85%A8%E4%B8%93%E5%9C%BA%20%20%E6%BD%98%E6%B6%A6%E7%BA%A2-%E8%87%B4%E8%BE%9E.mp4",
      "bgimg": "1"
    }
  ]
}


export default jinrong;